module.exports = __webpack_public_path__ + "static/media/gas-station-active.5119e2c9.svg";